<template>
  <Div class="add_department">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          ref="popupCheck"
          v-if="popup == 'check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess
          v-if="popup == 'success'"
          :text="successText"
          @check="poupupEnter"
        ></PopupSuccess>
        <PopupError
          v-if="popup == 'error'"
          :text="successText"
          @check="poupupEnter"
        ></PopupError>
      </Popup>
    </MyTransition>
    <div class="contain_white notice_block">
      <div class="form_input flex">
        <label>
          工作區域
          <span class="must">*</span>
        </label>
        <div>
          <input
            type="text"
            class="input_primary"
            v-model="formInput.location"
          />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          單位
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            class="input_primary"
            v-model="formInput.department_id"
            placeholder="choose role"
          >
            <el-option
              v-for="item in deportment_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          部門主管(平日)
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            v-model="formInput.admin"
            filterable
            multiple
            clearable
            value-key="account"
            placeholder="請選擇"
          >
            <el-option
              v-for="item in options.employee"
              :key="item.account"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="form_input flex">
        <label>
          部門主管(假日)
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            v-model="formInput.admin_h"
            filterable
            clearable
            value-key="account"
            placeholder="請選擇"
          >
            <el-option
              v-for="item in options.employee"
              :key="item.account"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div> -->
      <div class="form_input flex">
        <label> 備註 </label>
        <div>
          <textarea
            type="text"
            class="input_primary"
            v-model="formInput.remark"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="add_department_btn flex">
      <button class="btn_primary" @click="enter">送出</button>
      <button class="btn_gray" @click="returnLogin">返回</button>
    </div>
  </Div>
</template>
<style lang="scss">
.add_department {
  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;
    .notice_textarea {
      min-height: 200px;
    }
    label {
      flex: 2;
      font-weight: bold;
      span {
        color: var(--subColor);
      }
    }
    > div {
      flex: 8;
      input,
      textarea {
        width: 100%;
      }
    }
    .el-select {
      width: 100%;
      input {
        background-color: transparent;
      }
      .el-input__inner:focus {
        border-color: transparent;
      }
      button {
        outline: none;
        &:focus {
          border: 1px solid #e5e5e5;
        }
      }
    }
  }
  .file {
    .file_list {
      margin: 5px 0;
      padding: 10px 10px 10px 10px;
      border: 1px dashed #ccc;
      border-radius: 4px;
      p:first-child {
        flex: 3;
      }
    }
    .file_input {
      margin: 20px 0px;
      input {
        display: none;
      }
    }
    .btn_primary,
    .btn_error {
      font-size: 12px;
      cursor: pointer;
      font-weight: normal;
    }
  }
  .add_department_btn {
    width: 500px;
    margin: 20px auto;
    button {
      margin: 5px;
    }
  }
}
</style>

<script>
export default {
  name: "add-location",
  data() {
    return {
      formInput: {
        location: null,
        department_id: null,
        admin: null,
        // admin_h: null,
        remark: null,
      },
      deportment_list: [],
      popupStatus: false,
      successText: null,
      popup: null,
      fileList: [],
      options: {
        employee: [],
      },
      action: {
        index: null,
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  created() {
    if (this.id) {
      this.getData();
    }
    this.getOptions();
  },
  methods: {
    getData() {
      this.$http.api.admin.location(this.id).then((res) => {
        for (let key in this.formInput) {
          if(key=='admin'&&!Array.isArray(res.data[key])){
            this.formInput[key] = [res.data[key]];
          }else{
            this.formInput[key] = res.data[key];
          } 
          
        }
      });
    },
    getOptions() {
      //get department
      this.$http.api.admin.department().then((res) => {
        this.deportment_list = res.data.map((el) => {
          return {
            label: el.department,
            value: el.department_id,
          };
        });
      });
      //get employee
      this.$http.api.admin.employee().then((res) => {
        this.options.employee = res.data.map((el) => {
          return {
            account: el.ACCOUNT,
            email: el.EMAIL,
            name: el.NAME,
            user_guid: el.USER_GUID,
          };
        });
      });
    },
    returnLogin() {
      this.$router.go(-1);
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.returnLogin();
      }
    },
    enter() {
      //判斷新增或修改
      if (this.id) {
        //修改
        this.$http.api.admin
          .postLocation(this.formInput, this.id)
          .then((res) => {
            this.popupStatus = true;
            this.successText = "修改成功";
            this.popup = "success";
          })
          .catch((error) => {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "上傳失敗";
          });
      } else {
        this.$http.api.admin
          .postLocation(this.formInput)
          .then((res) => {
            this.popupStatus = true;
            this.successText = "新增成功";
            this.popup = "success";
          })
          .catch((error) => {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "上傳失敗";
          });
      }
    },
  },
};
</script>